import { render, staticRenderFns } from "./IconLowerThan.vue?vue&type=template&id=024a7de5"
import script from "./IconLowerThan.vue?vue&type=script&lang=ts"
export * from "./IconLowerThan.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports